'use strict';
import * as $j_be$002edoeraene$002ewebcomponents$002eui5$002econfigkeys$002e$002dEnumeration$002dString$0024$002dTuple$002dValue$002dOf from "./be.doeraene.webcomponents.ui5.configkeys.-Enumeration-String$-Tuple-Value-Of.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dTuple$0024package$0024$002dEmpty$002dTuple$0024 from "./scala.-Tuple$package$-Empty-Tuple$.js";
import * as $j_scala$002eruntime$002e$002dTuples$0024 from "./scala.runtime.-Tuples$.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$() {
  this.Do = null;
  this.Dp = false;
}
export { $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$ as $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$ as $h_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$ };
$h_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$.prototype = $p;
$p.Pc = (function() {
  if ((!this.Dp)) {
    this.Do = new $j_be$002edoeraene$002ewebcomponents$002eui5$002econfigkeys$002e$002dEnumeration$002dString$0024$002dTuple$002dValue$002dOf.$c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf($j_scala$002e$002dTuple$0024package$0024$002dEmpty$002dTuple$0024.$m_T$package$EmptyTuple$());
    this.Dp = true;
  }
  return this.Do;
});
$p.fj = (function(head, tail, ev) {
  return new $j_be$002edoeraene$002ewebcomponents$002eui5$002econfigkeys$002e$002dEnumeration$002dString$0024$002dTuple$002dValue$002dOf.$c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$TupleValueOf($j_scala$002eruntime$002e$002dTuples$0024.$m_sr_Tuples$().SU(head, tail.lr));
});
var $d_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$, "be.doeraene.webcomponents.ui5.configkeys.EnumerationString$", ({
  gs: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$ as $d_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$ };
var $n_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$;
function $m_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$)) {
    $n_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$ = new $c_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$ as $m_Lbe_doeraene_webcomponents_ui5_configkeys_EnumerationString$ };
